import React, {useState} from "react";
import {connect} from "react-redux";
import ActionButton from "../../components/ActionButton";
import {compactSerials} from "../../lib/SerialNumbers";
import {closeSerialNumbers} from "../../actions/SerialNumberActions";
import "./SerialNumbersWindow.scss";

// The serial numbers of one line, one per line, to read and copy.
const SerialNumbersWindow = ({serialNrs, closeSerialNumbers}) => {
  const [copied, setCopied] = useState(false);
  const serials = serialNrs || [];
  const text = serials.join("\n");

  function copy() {
    // The clipboard can refuse; the text stays selectable in the box either way.
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).then(() => setCopied(true), () => null);
    }
  }

  return (
    <div className="SerialNumbersWindow">
      <p>{serials.length} serial numbers: {compactSerials(serials).join(", ")}</p>
      <textarea id="serial-numbers" readOnly value={text} rows={Math.min(Math.max(serials.length, 4), 20)} />
      <div className="buttons">
        <ActionButton label={copied ? "Copied" : "Copy"} onClick={copy} />
        <ActionButton label="Close" primary={false} onClick={() => closeSerialNumbers()} />
      </div>
    </div>
  )
}

export default connect(null, {closeSerialNumbers})(SerialNumbersWindow);
